import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { hasInternalModelsAdmin, isAdminLocalDev } from './adminAccess'

export default function InternalModelsAdminRoute() {
  const { user, isLoading } = useAuth()

  if (isLoading) return null
  if (isAdminLocalDev() || hasInternalModelsAdmin(user)) return <Outlet />
  return <Navigate to="/dashboard" replace />
}
